export const alpha_num = (value) => {
    return /^[a-zA-Z0-9]+$/.test(value);
};
